import BaseButton from './BaseButton';

const VoidOrderButton = ({
  type = 'button',
  color = 'danger',
  text = 'Annulla',
  onClick,
  className,
  style,
  size,
}) => (
  <BaseButton type={type} color={color} onClick={onClick} className={className} style={style} size={size}>
    <i className="far fa-stop-circle" /> {text}
  </BaseButton>
);

export default VoidOrderButton;
